import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { ProjectBreadcrumb } from '@/features/estates/components/projectBreadcrumb';
import {
  requireGeneralRead,
  withNotFoundOnNoAccess,
} from '@/features/permissions/route-permissions';
import { useTrackProjectView } from '@/features/posthog/hooks/use-project-view';
import { getProject, getProjectQueryOptions } from '@/features/projects/api/projects';
import { ProjectTopRightFunction } from '@/features/projects/components/project-top-right-function';

const Component = () => {
  const projectId = Route.useParams().projectId;
  useTrackProjectView(projectId);

  return (
    <DashboardLayout type="project">
      <Outlet />
    </DashboardLayout>
  );
};

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout'
)({
  component: Component,
  // beforeLoad runs before child routes, so no tab requests data for a project without access.
  // It runs on every navigation, so it reads the query cache and the loader stays the fresh source.
  beforeLoad: async ({ context, params }) => {
    const project = await withNotFoundOnNoAccess(
      context.queryClient.ensureQueryData(getProjectQueryOptions(params.projectId))
    );

    requireGeneralRead(project.metadata?.permissions);

    return { project };
  },
  loader: async ({ params }) => {
    const project = await withNotFoundOnNoAccess(getProject(params.projectId));

    requireGeneralRead(project.metadata?.permissions);

    return project;
  },
  staticData: {
    breadcrumb: ProjectBreadcrumb,
    topRightFunction: ProjectTopRightFunction,
  },
});
